/* app/js/src/components/media-transcoder/jobs/job-settings/priotiry-level/priotiry-level.component.scss */
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host {
  width: 100%;
}
.container .dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 5px;
  border: 1px solid #f5f5f5;
  margin-right: 0.5vw;
}
.container > div {
  border: 1px solid #f5f5f5;
  cursor: pointer;
  padding: 0.5vw;
}
.container > div.active {
  border-width: 2px;
}
.container > div > div {
  padding: 0.1vw 0;
}
/*# sourceMappingURL=priotiry-level.component.css.map */
